import type {ReactNode} from 'react';
import * as z from 'zod';

import {AvatarVariant} from '..';

export const optionSchema = z.object({
  value: z.string(),
  label: z.string(),
  variant: z.nativeEnum(AvatarVariant).optional(),
});

export type SelectOption = z.infer<typeof optionSchema>;

export interface AvatarOptionNew extends SelectOption {
  avatar_url?: string;
  lifecycle_status?: string;
  primary_email?: string;
  avatar?: ReactNode;
  variant?: AvatarVariant;
}
